const tokenKey = 'bjToken'

// 获取url中的token
export function getUrlToken() {
    const searchParams = new URLSearchParams(window.location.search)
    const searchToken = searchParams.get('token')
    if (searchToken) {
        return searchToken
    }

    const hash = window.location.hash || ''
    const hashQuery = hash.includes('?') ? hash.slice(hash.indexOf('?') + 1) : ''
    const hashParams = new URLSearchParams(hashQuery)
    return hashParams.get('token') || ''
}

// 获取token
export function getToken() {
    const urlToken = getUrlToken()
    if (urlToken) {
        setToken(urlToken)
        return urlToken
    }
    let data = sessionStorage.getItem(tokenKey)
    return data ? data : ''
}

// 设置token
export function setToken(token) {
    return sessionStorage.setItem(tokenKey, token)
}

// 移除token
export function removeToken() {
    return sessionStorage.removeItem(tokenKey)
}
